import { RobotModel } from '@/interfaces'

export const UnknownModel: RobotModel = {
  id: '00000000-0000-0000-0000-000000000000',
  name: 'Unbekanntes Robotermodell',
  axisMaxRotations: [7_725_000, 6_100_000, 17_076_000, 5_171_000, 8_514_000, 22_503_000],
}
